import { isDecimalAmount } from '@platform/design-system';
import { z } from 'zod';
import type { Expense, ExpenseBody } from './finance.ts';

export const EXPENSE_LIMITS = { name: 200, note: 1000 } as const;

const CALENDAR_DAY = /^\d{4}-\d{2}-\d{2}$/u;

export const expenseFormSchema = z.object({
  name: z.string().trim().min(1).max(EXPENSE_LIMITS.name),
  amount: z
    .string()
    .trim()
    .refine((value) => isDecimalAmount(value.replace(',', '.'))),
  spentOn: z.string().regex(CALENDAR_DAY),
  subsidiaryId: z.string(),
  note: z.string().max(EXPENSE_LIMITS.note),
});

export type ExpenseFormValues = z.infer<typeof expenseFormSchema>;

export const expenseFormOf = (expense: Expense | null, today: string): ExpenseFormValues => ({
  name: expense?.name ?? '',
  amount: expense?.amount ?? '',
  spentOn: expense?.spentOn ?? today,
  subsidiaryId: expense?.subsidiaryId ?? '',
  note: expense?.note ?? '',
});

const orNull = (value: string): string | null => (value.trim() === '' ? null : value.trim());

export const expenseBodyOf = (values: ExpenseFormValues): ExpenseBody => ({
  name: values.name.trim(),
  amount: values.amount.trim().replace(',', '.'),
  spentOn: values.spentOn,
  subsidiaryId: orNull(values.subsidiaryId),
  note: orNull(values.note),
});
